import React, { useState, ChangeEvent, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Grid, Box, Typography } from '@mui/material';
import {
  ImageContainer,
  FormContainer,
  StyledButton,
  StyledTextField,
  GridContainer,
} from './ChangePassword.styles';
import BackGround from '../../../../Assets/AuthBackGround/AuthBG.png';
import { theme } from '../../../../theme';
import { getDecryptValue } from './decrypt';
import { validatePassword } from '../../Validation/validation';
import { useParams } from 'react-router-dom';
import { changePasword, validateSecretKey } from '../signApi';
import { useSnackbar } from '../../../../Context/SnackbarContext';

interface ChangePasswordProps { }

interface FormValues {
  newPassword: string;
  confirmPassword: string;
}

const ChangePassword: React.FC<ChangePasswordProps> = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [errors,setErrors]=useState<{ [key: string]: string }>({})
  const { tenant } = useParams<{ tenant: string }>();
  const [formValues, setFormValues] = useState<FormValues>({
    newPassword: '',
    confirmPassword: '',
  });
  const { showSnackbar } = useSnackbar();

  const encryptedData = searchParams.get('sxormoh5'); // Use the meaningless parameter name
  let userId = '';
  let userNum = '';
  let secretKey = '';
  let expiryTime: number | null = null; // Declare as number or null


  if (encryptedData) {
    const decryptedData = getDecryptValue(encryptedData);
    const [decUserId, decUserNum, decSecretKey, decExpiry] = decryptedData.split(':');
    userId = decUserId
    userNum =decUserNum
    secretKey = decSecretKey;
    expiryTime = parseInt(decExpiry, 10); // Ensure expiryTime is a number
  }

  useEffect(() => {
    const validateConditions = async () => {
      if (expiryTime !== null) { // Check if expiryTime is not null
        const currentTime = Math.floor(Date.now() / 1000);
        if (currentTime > expiryTime) {
          showSnackbar("The link has expired.","error")
          navigate(`/${tenant}/SignIn`);
          return;
        }
      }

      try {
        const payLoad={
          SecretKey: secretKey,
          UserNum: Number(userNum)
        }
        const response = await validateSecretKey(tenant,payLoad)
        if (!response) {
          showSnackbar("The link has expired.","error")
          navigate(`/${tenant}/SignIn`);
        }
      } catch (error) {
        showSnackbar("Something went wromg.Please try again.","error")
        navigate(`/${tenant}/SignIn`);
      }
    };

    validateConditions();
  }, [expiryTime, userNum, searchParams]);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
    setErrors((prevErrors)=>({
      ...prevErrors,
      [name]:''
    }))
  };

  const handleSubmit = async () => {
    // Implement password change logic here
    const newErrors: { [key: string]: string } = {};
    if (!validatePassword(formValues.newPassword)) {
      newErrors.newPassword='Password must be at least 8 characters long and include at least one uppercase letter, one number, and one special character.'
    }

    if (formValues.newPassword !== formValues.confirmPassword) {
      newErrors.confirmPassword='Passwords do not match.'
    }
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return
  }

    try {
      const payLoad={
        password: formValues.confirmPassword,
        SecretKey: secretKey,
        UserNum: Number(userNum)
      }
      const resposne = await changePasword(tenant,payLoad)
      if (resposne) {
        showSnackbar("Password has been changed successfully", "success")
        navigate(`/${tenant}/SignIn`);
      }else{
        showSnackbar("User not found. Please check your credentials.", "error")
      }
    } catch (error) {
      showSnackbar("Failed to change password.Please try again.", "error")
      console.log(error)
    }

  };



  return (
    <Grid container className="change-password-container" sx={{ height: '100vh', width: '100vw', overflow: 'hidden' }}>
      <Grid item xs={12} md={6} className="image-grid-item" sx={{ width: '50%', height: '100vh' }}>
        <ImageContainer
          sx={{
            backgroundImage: `url(${BackGround})`,
            height: '100vh',
            width: '100%',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
          className="image-container"
        />
      </Grid>

      <Grid item xs={12} md={6} className="form-grid-item" sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <FormContainer className="form-container" sx={{ width: '32vw', padding: '2rem' }}>
          <Box className="group-one" sx={{ width: '100%', marginBottom: '20px' }}>
            <Typography
              variant="h4"
              color={theme.palette.primary.main}
              className="change-password-title"
              sx={{ fontSize: '24px', fontWeight: 600, marginBottom: '15px' }}
            >
              Change Password
            </Typography>
            <Typography variant="subtitle1" className="instruction-text" sx={{ fontSize: '18px', color: '#92929D' }}>
              Please create a new password.
            </Typography>
          </Box>



          <Box className="group-two" sx={{ width: '100%' }}>
            <GridContainer container spacing={2} className="grid-container">
              <Grid item xs={12}>
                <StyledTextField
                  label="New Password"
                  type="password"
                  name="newPassword"
                  value={formValues.newPassword}
                  onChange={handleChange}
                  required
                  sx={{width:'30vw'}}
                  size="small"
                  className="styled-text-field"
                  error={!!errors.newPassword}
                  helperText={errors.newPassword}
                  autoComplete='off'
                />
              </Grid>
            </GridContainer>

            <GridContainer container spacing={2} className="grid-container-password">
              <Grid item xs={12}>
                <StyledTextField
                  label="Confirm New Password"
                  type="password"
                  name="confirmPassword"
                  value={formValues.confirmPassword}
                  onChange={handleChange}
                  fullWidth
                  required
                  size="small"
                  sx={{width:'30vw'}}
                  className="styled-text-field"
                  error={!!errors.confirmPassword}
                  helperText={errors.confirmPassword}
                  autoComplete='off'
                />
              </Grid>
            </GridContainer>

            <GridContainer container spacing={3} className="grid-container" sx={{ alignItems: 'center' }}>
              <Grid item xs={12}>
                <StyledButton
                  onClick={handleSubmit}
                  variant="contained"
                  color="primary"
                  fullWidth
                  size="small"
                  sx={{width:'30vw'}}
                  className="styled-button"
                >
                  Change Password
                </StyledButton>
              </Grid>
            </GridContainer>
          </Box>
        </FormContainer>
      </Grid>
    </Grid>
  );
};

export default ChangePassword;
